// @flow

import Alert from 'react-s-alert';
import _ from 'lodash';
import mapSeries from 'async/mapSeries';

import App from './App.jsx';

import {takeDir, takeFilename, noop, hs_bool} from './utils.js';
import {get_units_of_dir} from './fetch_things.js';

import type {T_Next, T_TifPngPairs, T_PngUnits} from './types.js';
import type {T_Stats} from './Stats.jsx';


const ELEM_FROM_TREE = false;   // NOTE: ¿DE DÓNDE SACO EL NOMBRE DEL ELEMENTO? DEL ARBOL (orden.js) O DE MATCH_FRIENDS (Pairs.hs)?


function is_good(st: T_Stats) {
  return _.has(st, 'png') && st.png !== 'NO-PNG-FRIEND-FOUND' && st.png !== 'unknown';
}



function match_friends(app: App, dir: string, ss: Array<T_Stats>, next: ((ss: Array<T_Stats>) => void)): void {
  if (_.isArray(ss) && ss.length > 0 && _.every(ss, is_good)) {
    next(ss);
  }
  else {
    const url = `${app.remote}/get-tif-png-pairs/?dir=${dir}&session_id=${app.session()}`;
    
    fetch(url).then(resp => resp.json()).then((fs: T_TifPngPairs) => {
      next(ss.map((st) => {
        const elem = _.findKey(fs, fp => fp[0] === st.tif);
        
        if (elem) {
          const pair = fs[elem];
          
          st.png  = pair[1];
          st.elem = elem;
        }
        
        return st;
      }));    
    });
  }
}



export type T_StatsErr = Array<T_Stats> | {error: string, razon: string};



function fix_ids(st: T_Stats): T_Stats {
  const ids = _.map(st.rows, 'ID');

  if (ids.length !== _.uniq(ids).length) {
    let count = 1;
    
    for (const row of st.rows) {
      row.ID = count;
      
      count++;
    }
  }
  
  return st;
}



export function load_stats(app: App, path: string, recalc: boolean, units: boolean, quiet: boolean, next: ((ss: Array<T_Stats>) => void)): void {
  const url = `${app.remote}/get-stats/?path=${path}&session_id=${app.session()}&recalc=${hs_bool(recalc)}`,
        dir = takeDir(path);
  
  fetch(url).then(resp => resp.json()).then((ss0: T_StatsErr) => {
    if (ss0.error && typeof ss0.error === 'string') {
      let msg_end = ss0.error,
          timeout = 3000;
      
      if (! quiet) {
        Alert.error(ss0.error, {position: 'top-right'});
      }
      
      if (ss0.razon != null && typeof ss0.razon === 'string') {
        const razon      = ss0.razon,                                   // eslint-disable-line prefer-destructuring
              [msg, arr] = _.tail(razon.split(':')).map(xx => xx.trim()),
              bad_type   = arr.indexOf('.0000') !== -1,
              msg_type   = bad_type ? 'La columna ID debería ser de tipo Int, pero es Float.' : '';
        
        msg_end += `<br />${bad_type ? msg_type : msg}`;
        timeout = 10000;
      }
      
      if (! quiet) {
        Alert.error(msg_end, {position: 'bottom-right', offset: 300, timeout, html: true});
      }
      
      if (app.toolbar != null && app.toolbar.state.stats_recalc) {
        app.toolbar.setState({stats_recalc: false});
      }
      
      next([]);
    }
    else if (ss0 instanceof Array) {
      match_friends(app, dir, ss0, (ss_: Array<T_Stats>) => {     // NOTE: puede que el shp no esté cargado, porque se pidió
        const ss = ss_.map(fix_ids),
              is_loaded = _.has(app.map_ui.map.Shp_List, path),  // las stats de otro culti en otro servicio en DialogThematic.
              num_recs  = is_loaded ? app.map_ui.map.Shp_List[path].obj.dbfRecords.length : -1;
        
        if (is_loaded) {
          if (app.map_ui.map.Shp_List[path].obj.dbfRecords[0].ID !== 1) {
            if (! quiet) {
              Alert.error(
                'El dbf del cultivable no empieza en 1.',
                {position: 'top-right', offset: 50, timeout: 15000, html: true}
              );
            }
          }
          
          if (ss.length > 0 && num_recs !== ss[0].rows.length) {
            if (! quiet) {
              Alert.error(
                'El número de registros de las estadísticas y el dbf no coinciden.',
                {position: 'bottom-right', offset: 50, timeout: 15000, html: true}
              );
            }
          }
        }
        
        if (is_loaded) {
          ss.forEach((st) => {
            const num_rows = st.rows.length,
                  min      = Math.min(num_recs, num_rows);
            
            _.zip(_.take(app.map_ui.map.Shp_List[path].obj.dbfRecords, min), _.take(st.rows, min)).forEach(([drec, row]) => {
              row.ID = parseInt(row.ID, 10);
              
              if (typeof drec.NOMBRE === 'string') {
                row.Nombre = drec.NOMBRE;
              }
              
              if (typeof drec.HECTAREAS === 'number') {
                row.Has = drec.HECTAREAS;
              }
            });
          });
        }
        
        const ss2 = ss.map((st) => {
          if (ELEM_FROM_TREE) {
            const item_png = app.get_item_png(`${dir}/${st.png}`);
            
            if (item_png != null) {
              st.elem = item_png.props.node.label;
            }            
          }
          
          st.culti = path;
          st.path = `${dir}/${st.tif}`;
          
          return st;
        });
        
        if (! units) {
          next(ss2);
        }
        else {
          get_units_of_dir(app, dir, (png_units: T_PngUnits) => {
            next(ss2.map((st) => {
              if (png_units[st.png] && typeof png_units[st.png] === 'string') {
                st.units = png_units[st.png];
              }
              
              return st;
            }));
          });
        }
      });
    }
  });
}



// setea en app.map_ui.Lim_List los límites [min, max] de todos los png_files asociados a path:

export function get_stats_limits(app: App, path: string, next: T_Next): void {
  const dir = takeDir(path);
  
  if (_.includes(_.keys(app.map_ui.Lim_List), dir)) {
    next(true);
  }
  else {
    const dir     = takeDir(path),
          is_diff = takeFilename(dir) === 'Mapas_Diferenciales',
          dict    = {};
    
    load_stats(app, path, false, false, true, (ss: Array<T_Stats>) => {
      if (is_diff) {
        const png_paths = app.get_images_of(dir).map(item => item.get_path());
        
        mapSeries(png_paths, (png_path, callback) => {
          const jpath = `${png_path}.minmax.json`,
                url   = `${app.remote}/get-json/?path=${jpath}&session_id=${app.session()}`;
          
          fetch(url).then(resp => resp.json()).then((res) => {
            if (res instanceof Array) {
              dict[takeFilename(png_path)] = res;              
            }
            
            callback(null, true);
          });
        }, (err, rs) => {
          app.map_ui.Lim_List[dir] = dict;
          
          next(true);
        });
      }
      else {
        ss.forEach((st) => {
          dict[st.png] = [st.total.Min, st.total.Max];
        });
        
        app.map_ui.Lim_List[dir] = dict;
        
        next(true);
      }
    });
  }
}




export default function show_stats(app: App, path: string, next: T_Next = noop, recalc: boolean = false, units: boolean = false): void {
  if (app.toolbar != null) {
    app.toolbar.setState({show_menu_stats: false});
  }
  
  if (app.toolbar != null && app.toolbar.state.stats && app.toolbar.state.stats.culti && app.toolbar.state.stats.culti === path) {
    return next(false);
  }
  
  const dir = takeDir(path);
  
  if (app.toolbar != null) {
    app.toolbar.setState({stats_recalc: true, stats: null});
  }
  
  load_stats(app, path, recalc, units, ! app.agrosat_user, (ss: Array<T_Stats>) => {
    const preamble = (fun = noop): void => {
      fun(true);
    };
    
    preamble((result: boolean) => {
      if (app.toolbar != null) {
        const {toolbar} = app;
        
        toolbar.all_stats = ss;
        
        ss.forEach((st) => {
          if (app.agrosat_user && st.warn != null && typeof st.warn === 'string') {
            const {warn} = st,
                  msg    = (warn.indexOf("Can't parse tag TagSampleFormat") !== -1 ?
                              'El raster tiene un formato ilegible. Las estadísticas probablemente están malas.'
                           :
                              warn);
            
            console.log(warn);
            
            if (warn !== "Can't find row per strip") {
              Alert.error(`${takeFilename(st.path)}: ${msg}`, {timeout: 10000});
            }
          }
        });
        
        const end = (first_png) => {
          const stats = _.find(toolbar.all_stats, st => st.png === first_png);
          
          if (stats != null) {
            toolbar.setState({stats, stats_recalc: false}, () => {
              next(true);
            });
          }
          else {
            next(false);
          }           
        };
        
        const item_opened = app.get_opened_image_of(dir);
        
        if (item_opened != null) {
          end(item_opened.props.node.File);
        }
        else {
          const item_first = app.get_first_image_of(dir);
          
          if (item_first != null) {
            const {File} = item_first.props.node;
            
            item_first.open(() => {
              end(File);
            });
          }
        }
      }
    });
  });
}



// WEBPACK FOOTER //
// ./src/show_stats.js